@if (loading) {
  <div class="loading-screen">
    <div class="loading-animation">
      <p-progressSpinner strokeWidth="8" [style]="{width: '50px', height: '50px'}">
      </p-progressSpinner>
    </div>
  </div>
}
